import React from 'react';
import Switch from 'react-switch';

class SwitchButton extends React.Component {

    handleSwitch(name, value) {
        console.log(name, value);
        this.props.onChange(name, !value);
    }

    render() {
        return (
            <div className="ln-c-form-group">
                {this.props.label && <label className="ln-c-label" htmlFor={this.props.name}>{this.props.label}{this.props.asterix ? <span className="asterix">*</span> : ''}</label>}
                <div style={{ paddingTop: 5 }}>
                    <div style={{ float: 'left', marginRight: 5 }}>
                        <Switch
                            onChange={() => this.handleSwitch(this.props.name, this.props.value)}
                            checked={this.props.value}
                            id="normal-switch"
                            className='switch'
                            height={this.props.height ? this.props.height : 28}
                            width={this.props.width ? this.props.width : 56}
                            disabled={this.props.disabled ? this.props.disabled : false}
                        />
                    </div>
                    {this.props.text && <span style={{ float: 'left', fontSize: 11, lineHeight: this.props.height ? `${this.props.height + 2}px` : '30px' }}>{this.props.text}</span>}
                </div>
            </div>
        )
    }

};

export default SwitchButton;